<script>
import { iIcon } from '@inscribe/signal';

export default {
  components: { iIcon },
  props: {
    text: {
      type: String,
      default: '',
    },
  },
};
</script>

<template>
  <div class="ai-tag d-flex flex-row align-items-center i-gap-3">
    <i-icon symbol="small-user-scan" class="i-text-neutral-90" :size="12" />
    <span class="i-text-subheading-3 i-text-neutral-120">
      {{ text }}
    </span>
  </div>
</template>
